import WebComponent from "../../WebComponent";
import ZVVDto from "./ZVVDto";
import {html} from "@isceco/widget-library2/external/lit";
import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Button/Button.js'
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import BerechtigungUtil from "../../services/BerechtigungUtil";
import ZVVEinladungService from "./ZVVEinladungService";
import BerechtigteListService from "../../services/BerechtigteListService";
import ZVVService from "./ZVVService";
import ZVVMitgliederColumns from "./ZVVMitgliederColumns";
import ZVVMitgliedDto from "./ZVVMitgliedDto";
import ZVVMitgliederEinladungenColumns from "./ZVVMitgliederEinladungenColumns";
import ZVVEinladungDto from "./ZVVEinladungDto";
import {List} from "@isceco/widget-library2/basic-elements/List/List";

export default class ZVVMitglieder extends WebComponent {

  static get properties() {
    return {
      zvv: {type: ZVVDto}
    }
  }

  constructor() {
    super();
    this.zvvEinladungService = new ZVVEinladungService(getNavigationId())
    this.zvvService = new ZVVService(null, getNavigationId())
    this.showZVVEinladungCreateDialog = false;
  }

  get translationFile() {
    return './views/ZVV/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.zvvService.getBackendListUrl('member'),
      this.zvvEinladungService.getBackendListUrl()
    ]).then(([mitgliederUrl, einladungenUrl]) => {
      this.mitgliederUrl = mitgliederUrl
      this.einladungenUrl = einladungenUrl
    })
      .catch(() => {
        this.mitgliederUrl = ''
      })
      .finally(() => this.render())
  }

  getTemplate() {
    const isKi = new BerechtigungUtil().getActiveProfile().uuid === this.zvv.koordinierenderBenutzer.uuid
    return html`
      <isceco-list id="zvv-mitglieder-list"
                   identifier="mitglieder"
                   url="${this.mitgliederUrl}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toZVVMitgliedDto}"
                   .columns="${ZVVMitgliederColumns.getColumns(isKi)}"
                   .listService="${BerechtigteListService}"
                   order="asc"
                   .rowVariant="${ZVVMitgliederColumns.getRowVariant()}"
      ></isceco-list>
      <isceco-title size="medium" text="${this.i18n.translate('zvv.einladungen.title')}">
        ${this._getButtons()}
      </isceco-title>
      <isceco-list id="zvv-einladungen-list"
                   identifier="einladungen"
                   url="${this.einladungenUrl}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toZVVEinladungDto}"
                   .columns="${ZVVMitgliederEinladungenColumns.getColumns(isKi)}"
                   .listService="${BerechtigteListService}"
                   order="asc"
                   .rowVariant="${ZVVMitgliederEinladungenColumns.getRowVariant()}"
      ></isceco-list>
    `
  }

  _getButtons() {
    if (new AuthorizationFilter().roles.GP_SUPERUSER &&
    new BerechtigungUtil().getActiveProfile().uuid === this.zvv.koordinierenderBenutzer.uuid) {
      return html`
        <isceco-button id="create-einladung-button" size="small" variant="primary" icon="plus"
                       text="${this.i18n.translate('zvv.mitglieder.create.einladung')}"
                       @click="${_ => this._toggleZVVEinladungCreateDialog(true)}"
                       .disabled="${this.zvv.isAktiveKontingentierung}"
        ></isceco-button>
        ${this._renderEinladungCreateDialog()}
      `
    }

    return html``
  }

  _renderEinladungCreateDialog() {
    if (this.showZVVEinladungCreateDialog) {
      return html`
        <isceco-dialog id="zvv-einladung-create-dialog"
                       header="${this.i18n.translate('zvv.mitglieder.create.einladung.header')}"
                       confirm-button="${this.i18n.translate('zvv.mitglieder.create.einladung.confirm')}"
                       cancel-button="${this.i18n.translate('zvv.mitglieder.create.einladung.cancel')}"
                       @submit="${event => this._handleSubmitCreateEinladung(event)}">
          <isceco-form id="zvv-einladung-create-form">
            <div slot="form-elements" class="form-container">
              <isceco-text-input
                name="gpIdVnb"
                label="${this.i18n.translate('zvv.mitglieder.create.einladung.gpIdVnb')}"
                required
              ></isceco-text-input>
            </div>
          </isceco-form>
        </isceco-dialog>
      `
    }
    return html``
  }

  _handleSubmitCreateEinladung = event => {
    if (!event.detail.confirmed) {
      this._toggleZVVEinladungCreateDialog(false)
      return
    }
    const form = document.getElementById('zvv-einladung-create-form')
    if (form.validate()) {
      this.zvvEinladungService.create(form.getValues())
        .then(einladung => {
          window.showAlert(this.i18n.translate('zvv.mitglieder.create.einladung.success', {extId: einladung.gpIdVnb}), "", 'success')
        })
        .finally(() => {
          this.reload()
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladungen'})
          this._toggleZVVEinladungCreateDialog(false)
        })
    }
  }

  _toggleZVVEinladungCreateDialog(show) {
    this.showZVVEinladungCreateDialog = show
    this.render()
  }

  _toZVVMitgliedDto = row => new ZVVMitgliedDto(row)

  _toZVVEinladungDto = row => new ZVVEinladungDto(row)

}
customElements.define('eko-frontend-zvv-mitglieder', ZVVMitglieder)
